import { render, staticRenderFns } from "./r-challenge-config-dialog.vue?vue&type=template&id=79954d0b"
import script from "./r-challenge-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-challenge-config-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79954d0b')) {
      api.createRecord('79954d0b', component.options)
    } else {
      api.reload('79954d0b', component.options)
    }
    module.hot.accept("./r-challenge-config-dialog.vue?vue&type=template&id=79954d0b", function () {
      api.rerender('79954d0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/challenge/r-challenge-config-dialog.vue"
export default component.exports